// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoContainerWrapper_Cy9El {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  justify-content: space-between;
}

.infoContainer_kKQSN {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  cursor: pointer;
  div {
    color: var(--_1f184b-color);
    font-size: 12px;
    font-weight: 500;
  }

  span {
    color: var(--_1f184b-color);
    font-size: 12px;
    font-weight: 300;

    @media (width<=768px) {

      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.editableInputHeader_zrl39 {
  p {
    margin: 0;
  }
}

.editableInput_nZGPQ{

 .textareaContainer_uuIc2{
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 93%;

  textarea{
    resize: none;
  }

  >div{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    span{
      font-size: 12px;
      font-weight: 300;
      color: var(--_1f184b-color);
    }
  }
 } 
}


.contentContainer_b_IbC {
  >div >p{
    
    color: var(--_1f184b-color);
    font-size: 13px;
    line-height: 1;
    display: flex
;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0px solid var(--e8-border);
    border-top: 0px solid var(--e8-border);
    margin-top: 0px;
    margin-bottom: 0px;
    margin-bottom: 6px;
  }
  &.active_x5NVo {
    display: block;
  }

  &.disabled_JKBBq {
    display: none;
  }
}

.inputTypeClient_Gle3s {
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  min-height: 21px !important;
  background-color: var(--f4-background);
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
  padding: 8px;

  &::placeholder {
    color: var(--_75-color);
  }
}

.keywordContainer_r8X1i {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;

  .keyword_s442u {
    display: flex;
    gap: 9px;
    padding: 3px 12px;
    border-radius: 30px;
    border: 1px solid var(--e0e3e6-border); 
    align-items: center;
  }
}

.cardTypesContainer_nE0lA {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}

.singleTypeCard_weBY_ {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid var(--e0e3e6-border) ;

  span {
    font-size: 12px;
    font-weight: 400;
    color: var(--_2a2e32-color);
    -webkit-user-select: none;
            user-select: none;
  }
}

.messageConfigurationContainer_dT5l6 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.selectedVariablesContainer_aOB_b {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0;

  .selectedVariables__DbLD {
    display: flex;
    gap: 9px;
    padding: 3px 12px;
    border-radius: 30px;
    border: 1px solid var(--e0e3e6-border) ;
    align-items: center;
    width: fit-content;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/FileInput/FileInput.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV,eAAe;EACf;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;;IAEhB;;MAEE,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;MAChB,uBAAuB;IACzB;EACF;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;;CAEC;EACC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;;EAEV;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR;MACE,eAAe;MACf,gBAAgB;MAChB,2BAA2B;IAC7B;EACF;CACD;AACD;;;AAGA;EACE;;IAEE,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd;AACJ;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,yCAAyC;IACzC,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;;EAEZ;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;;EAEb;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;;EAEvC;IACE,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;;EAEd;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  justify-content: space-between;\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  cursor: pointer;\n  div {\n    color: var(--_1f184b-color);\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  span {\n    color: var(--_1f184b-color);\n    font-size: 12px;\n    font-weight: 300;\n\n    @media (width<=768px) {\n\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n\n.editableInputHeader {\n  p {\n    margin: 0;\n  }\n}\n\n.editableInput{\n\n .textareaContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 93%;\n\n  textarea{\n    resize: none;\n  }\n\n  >div{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n    span{\n      font-size: 12px;\n      font-weight: 300;\n      color: var(--_1f184b-color);\n    }\n  }\n } \n}\n\n\n.contentContainer {\n  >div >p{\n    \n    color: var(--_1f184b-color);\n    font-size: 13px;\n    line-height: 1;\n    display: flex\n;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 0px solid var(--e8-border);\n    border-top: 0px solid var(--e8-border);\n    margin-top: 0px;\n    margin-bottom: 0px;\n    margin-bottom: 6px;\n  }\n  &.active {\n    display: block;\n  }\n\n  &.disabled {\n    display: none;\n  }\n}\n\n.inputTypeClient {\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-weight: 400;\n  min-height: 21px !important;\n  background-color: var(--f4-background);\n  border-radius: 5px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 8px;\n\n  &::placeholder {\n    color: var(--_75-color);\n  }\n}\n\n.keywordContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n\n  .keyword {\n    display: flex;\n    gap: 9px;\n    padding: 3px 12px;\n    border-radius: 30px;\n    border: 1px solid var(--e0e3e6-border); \n    align-items: center;\n  }\n}\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid var(--e0e3e6-border) ;\n\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--_2a2e32-color);\n    user-select: none;\n  }\n}\n\n.messageConfigurationContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.selectedVariablesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 10px 0;\n\n  .selectedVariables {\n    display: flex;\n    gap: 9px;\n    padding: 3px 12px;\n    border-radius: 30px;\n    border: 1px solid var(--e0e3e6-border) ;\n    align-items: center;\n    width: fit-content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainerWrapper": `infoContainerWrapper_Cy9El`,
	"infoContainer": `infoContainer_kKQSN`,
	"editableInputHeader": `editableInputHeader_zrl39`,
	"editableInput": `editableInput_nZGPQ`,
	"textareaContainer": `textareaContainer_uuIc2`,
	"contentContainer": `contentContainer_b_IbC`,
	"active": `active_x5NVo`,
	"disabled": `disabled_JKBBq`,
	"inputTypeClient": `inputTypeClient_Gle3s`,
	"keywordContainer": `keywordContainer_r8X1i`,
	"keyword": `keyword_s442u`,
	"cardTypesContainer": `cardTypesContainer_nE0lA`,
	"singleTypeCard": `singleTypeCard_weBY_`,
	"messageConfigurationContainer": `messageConfigurationContainer_dT5l6`,
	"selectedVariablesContainer": `selectedVariablesContainer_aOB_b`,
	"selectedVariables": `selectedVariables__DbLD`
};
export default ___CSS_LOADER_EXPORT___;
